import { Certificate } from '@legacy-types';
import { CreateCertificateData } from '@shared/certificates/endpoints/createCertificateForUserAndCompany';
import { FileField } from '@shared/forms/components/FileField';
import { Form, useForm } from '@shared/forms/components/Form';
import { SelectField } from '@shared/forms/components/SelectField';
import { TextField } from '@shared/forms/components/TextField';

import { certificateTypeOptions } from './certificateTypeOptions';

type CertificateFormProps = {
  action: (data: CreateCertificateData) => Promise<Certificate>;
  onSave: () => void;
  onCancel: () => void;
  companies?: { label: string; value: number; }[];
};

export function CertificateForm({ action, onSave, onCancel, companies }: CertificateFormProps) {
  const { form, fields } = useForm<CreateCertificateData>();

  return (
    <Form form={form} action={action} onSave={onSave} onCancel={onCancel}>
      {(companies) && <SelectField name={fields.companyId} label="Company" options={companies} required />}
      <SelectField name={fields.type} label="Type" options={certificateTypeOptions} required />
      <TextField
        name={fields.description}
        label="Description"
        placeholder="e.g. 'For the 10 meter telehandler'"
        required
      />
      <TextField name={fields.expiresAt} type="date" label="Expiration" />
      <FileField name={fields.files} label="Files" required />
    </Form>
  );
}
